import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { IndustryDetail } from 'app/shared/models/evilo-models';
import { BusinessService } from './../../../../services/business/business.service';
import { FieldType } from '@ngx-formly/core';
import { NgSelectComponent, NgLoadingSpinnerTemplateDirective } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-select-industry',
    templateUrl: './select-industry.component.html',
    styleUrls: ['./select-industry.component.scss'],
    imports: [NgSelectComponent, FormsModule, NgxIntlTelInputModule, NgLoadingSpinnerTemplateDirective, AsyncPipe]
})
export class SelectIndustryComponent extends FieldType implements OnInit {

  industry$: Observable<IndustryDetail[]>;
  industryLoading = false;
  industryInput$ = new Subject<string>();
  @Input() placeholder: string = "Please select associated industry";
  @Input() allowAdding: boolean = false;
  @Input() allowMultiple: boolean = false;
  @Input() preSelectedIndustry: IndustryDetail = null;
  @Input() readonly: boolean = false;
  @Output() selectedIndustries = new EventEmitter();

  selectedIndustry: IndustryDetail | IndustryDetail[] = null;


  constructor(private businessService: BusinessService) {
    super();
  }

  ngOnInit() {
    this.loadIndustry();
    if (this.field && this.props) {
      if (this.props.placeholder !== undefined && this.props.placeholder !== null  && this.props.placeholder !== "") {
        this.placeholder = this.props.placeholder;
      }
      
      if (this.props.multiple !== undefined && this.props.multiple !== null) {
        this.allowMultiple = this.props.multiple;
      }
      
      if (this.props.allowAdding !== undefined && this.props.allowAdding !== null) {
        this.allowAdding = this.props.allowAdding;
      }
      
      if (this.props.readonly !== undefined && this.props.readonly !== null) {
        this.readonly = this.props.readonly;
      }
    }
    console.log('allowMultiple value is ', this.allowMultiple)
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("preselected industry is :", this.preSelectedIndustry)
    if (this.preSelectedIndustry && !this.selectedIndustry) {
      console.log("setting industry preselection")
      if (this.allowMultiple)
        this.selectedIndustry = [this.preSelectedIndustry];
      else
        this.selectedIndustry = this.preSelectedIndustry;
      this.selectedIndustries.emit(this.preSelectedIndustry);
    }
  }

  trackByFnIndustry(item: IndustryDetail) {
    return item.industryID
  }

  private loadIndustry() {
    this.industry$ = concat(
      of([]), // default items
      this.industryInput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => this.industryLoading = true),
        switchMap(term => this.businessService.searchIndustry(term).pipe(
          catchError(() => of([])), // empty list on error
          tap(() => this.industryLoading = false)
        ))
      )
    );
  }

  onIndustrySelectChange(event) {
    console.log("selection changed: added ", event);
    if (event) {
      this.selectedIndustries.emit(event);
      if (this.field && this.field.templateOptions) {
        this.formControl.setValue(event.industryID)
        // this.field.templateOptions.onContactSelectionChange(event);
        // console.log("the field : ", JSON.stringify(this.field))
      }
    }
  }

  onIndustrySelectRemove(event) {
    console.log("selection removed: removed ", event);
    if (event) {
      this.selectedIndustries.emit(event);
      if (this.field && this.field.templateOptions) {
        this.formControl.setValue(event.industryID)
        // this.field.templateOptions.onContactSelectionChange(event);
        // console.log("the field : ", JSON.stringify(this.field))
      }
    }
  }

}
